import React, { useEffect, useMemo } from 'react';
import { Layout, Col, Row } from 'tea-component';
import { connect, useDispatch, useIntl } from 'umi';
// 下载弹窗
import Metrics from '@op/widgets/metrics';
import MentionsSentiment from './components/MentionsSentiment';
import TopicKeyword from './components/TopicKeyword';
import GameStore from './components/GameStore';
import ChannelsLanguage from './components/ChannelsLanguage';
import RegionMarket from './components/RegionMarket';
import '@op/assets/scss/pages/performance/index.scss';
import { FilterFixed, useFilterDataHook } from '../../components/FilterCommon';
import CardLoading from '../../components/CardLoading';
import { localStoreSaveCountryToRegion } from '../../utils';
import { v4 as uuidv4 } from 'uuid';
import UserGuideOverview from '@op/components/UserGuide/overview';
import UserGuideCompetitor from '@op/components/UserGuide/competitor';
import { useInitBuriedPointInfo } from '../../operationLog/buriedPoint';
import performancePoint from '@op/operationLog/pages/performance';
import useTranslateTopic from '../../hooks/useTranslateTopic';
import ContentBody from '../../components/ContentBody';
import MentionsRight from './components/MentionsRight';
import UrlButton from './components/UrlButton';
import { useDashboardGamePermissions } from './hooks/useGamePermissions';
import { intelligenceMapTips } from '../../components/BubbleCommon';
import { PAGE_NAME } from '@op/constants/page';
import { getOtherSystemUrl } from '@op/utils/url';
const { Content } = Layout;

function Performance({ gameInfo, userInfo, wholeGameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: performancePoint });
  const {
    dashboardUrl,
    showDashboardBtn,
    dashboardBtnDisabled,
    dashboardTipsMap,
  } = useDashboardGamePermissions({
    gameInfo,
  });

  const { formatMessage } = useIntl();

  const {
    scrollBody,
    loading,
    filter,
    changeFilter,
    filterOptions,
    initState,
    filterCommonParams,
  } = useFilterDataHook({ gameInfo, pageName: 'Overview_Performance' });

  const { setTranslateTopicMap, translateTopic } = useTranslateTopic();

  const uniqueId = useMemo(() => uuidv4(), [filter, gameInfo, userInfo]);
  // console.log(gameChangeLoading, '----------------');
  return (
    <Content className="dbo-page dbo-performance" ref={scrollBody}>
      <ContentBody
        pageName={PAGE_NAME.PERFORMANCE}
        GotoFeeds
        contentHeard={
          <Content.Header
            className="dbo-header"
            title={formatMessage({ id: PAGE_NAME.PERFORMANCE })}
            operation={
              <>
                <UrlButton
                  url={dashboardUrl}
                  showBtn={showDashboardBtn}
                  buttonText="Dashboard"
                  disabled={dashboardBtnDisabled}
                  bubbleContent={dashboardTipsMap}
                ></UrlButton>
                <UrlButton
                  url={getOtherSystemUrl(gameInfo)}
                  buttonText="Intelligence"
                  bubbleContent={intelligenceMapTips}
                ></UrlButton>
              </>
            }
          ></Content.Header>
        }
      >
        <FilterFixed
          scrollBody={scrollBody}
          filter={filterOptions}
          confirm={(value: any) => {
            changeFilter(value);
          }}
          backCondOriginData={(options) => {
            localStoreSaveCountryToRegion(options?.region_country);
            setTranslateTopicMap(options?.topic_trans || []);
          }}
          {...filterCommonParams}
        ></FilterFixed>

        <CardLoading loading={loading}>
          <UserGuideOverview></UserGuideOverview>
          <UserGuideCompetitor></UserGuideCompetitor>

          <Metrics
            filter={filter}
            title={formatMessage({ id: 'Key Metrics' })}
          ></Metrics>
          <Row className="dbo-cardrow-wrap">
            <Col className="mentions-left">
              {/* 使用 uniqueID key 重置组件 */}
              <MentionsSentiment
                filter={filter}
                key={`mentions-sentiment${uniqueId}`}
              />
            </Col>
            <Col span={8} className="mentions-right" style={{ width: '516px' }}>
              <MentionsRight
                filter={filter}
                gameInfo={gameInfo}
                wholeGameInfo={wholeGameInfo}
              ></MentionsRight>
            </Col>
          </Row>
          <TopicKeyword filter={filter} translateTopic={translateTopic} />

          {/* 注意：里面写了三种不同游戏类型的情况 */}
          <GameStore filter={filter} />

          <ChannelsLanguage filter={filter} />
          <RegionMarket filter={filter} />
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: any) => {
  const { loading, home, opinionCommon, opinionFilter } = state;
  // console.log('connect', opinionFilter);
  return {
    userInfoLoading: loading.effects['home/getUserInfo'],
    userInfo: home.userInfo,
    gameInfo: opinionCommon.gameInfo,
    filter: opinionFilter,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(Performance);
